import { isTableMetricReportEditorSchema } from 'reporting-data/tsTypes/editorTypes';
import BaseTableMetricsEditor from './BaseTableMetricEditor';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { getDataType } from 'reporting-data/report/configReportGetters';
import { DATA_TYPE_TO_HUBSPOT_OBJECT_COORDINATES } from 'reporting-data/constants/objectCoordinates';
import { getTableMetricEditorSchema } from 'reporting-data/report/reportEditorsGetters';
import { getReportEditorsSchema } from 'reporting-data/report/reportGetters';
import { ReportOptionsCategories } from '../../singleReportViewer/fullPage/sidebar/categorized/ReportOptionCategory';
import { jsx as _jsx } from "react/jsx-runtime";
export const strategy = {
  getCurrentValue: report => {
    const schema = getTableMetricEditorSchema(report);
    return schema ? schema.get('selectedMetrics', []) : [];
  },
  getDataType: report => {
    const dataType = getDataType(report);
    return DATA_TYPE_TO_HUBSPOT_OBJECT_COORDINATES.get(dataType) || dataType;
  },
  isSupportedForReport: report => {
    return isConfigReport(report);
  },
  updateReport: (metrics, report) => {
    const schemaIndex = getReportEditorsSchema(report).findIndex(schema => schema ? schema.get('type') === 'TABLE_METRIC' : false);
    return report.setIn(['editors', schemaIndex, 'selectedMetrics'], metrics);
  }
};
const SingleObjectTableMetricsEditorComponent = props => {
  return /*#__PURE__*/_jsx(BaseTableMetricsEditor, Object.assign({}, props, {
    strategy: strategy,
    schema: props.schema
  }));
};
export const SingleObjectTableMetricsEditor = {
  matchesEditorType: (report, schema) => {
    if (!isTableMetricReportEditorSchema(schema)) {
      return false;
    }
    return strategy.isSupportedForReport(report);
  },
  EditorComponent: SingleObjectTableMetricsEditorComponent,
  category: ReportOptionsCategories.Define
};